import React from 'react';
import { Pencil, Trash2 } from 'lucide-react';

const MemberList = ({ members, onEdit, onDelete }) => {
    if (!members || members.length === 0) {
        return <p className="text-center text-gray-500">No members found.</p>;
    }

    return (
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {members.map(member => (
                <div key={member.id} className="bg-white p-4 rounded-lg shadow flex flex-col items-center text-center">
                    {member.profilePictureUrl && (
                        <img src={member.profilePictureUrl} alt={`${member.firstName} ${member.lastName}`} className="w-24 h-24 object-cover rounded-full mb-4" />
                    )}
                    <div className="mb-4">
                        <h3 className="text-lg font-semibold text-gray-800">{member.firstName} {member.lastName}</h3>
                        <p className="text-sm text-gray-600">{member.position}</p>
                    </div>
                    <div className="flex space-x-2 mt-auto">
                        <button
                            onClick={() => onEdit(member)}
                            className="p-2 rounded-full bg-blue-100 text-blue-600 hover:bg-blue-200 transition"
                            aria-label={`Edit ${member.firstName} ${member.lastName}`}
                        >
                            <Pencil size={20} />
                        </button>
                        <button
                            onClick={() => onDelete(member.id)}
                            className="p-2 rounded-full bg-red-100 text-red-600 hover:bg-red-200 transition"
                            aria-label={`Delete ${member.firstName} ${member.lastName}`}
                        >
                            <Trash2 size={20} />
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default MemberList;